window.customElements.define('page-language', class extends HTMLElement {
  constructor() {
    super();
    this.$content = this.querySelectorAll('.language__content');
    this.$trigger = this.querySelectorAll('.language__trigger');
    this.$return = this.querySelectorAll('.language__return');

    window.addEventListener('click', (e) => {
      if (!e.target.closest('page-language')) {
        this.hideLang();
      }
    });

    this.addEventListener('click', (e) => {
      const $currentSub = e.target.nextElementSibling;
      if ($currentSub && $currentSub.classList.contains('language__content')) {
        e.preventDefault();
        $currentSub.classList.toggle('is-active');
        e.target.classList.toggle('is-active');
      }
    });

    this.$return.forEach(($returnElement) => {
      $returnElement.addEventListener('click', (e) => {
        e.preventDefault();
        this.hideLang();
      });
    });

    window.addEventListener('scroll', () => {
      this.hideLang();
    });
  }

  hideLang() {
    this.$content.forEach(($sub) => $sub.classList.remove('is-active'));
    this.$trigger.forEach(($link) => $link.classList.remove('is-active'));
  }
});
